import React from "react";
import { notifyError } from "../notify";
import Cleave from "cleave.js/react";

import { useLoading } from "../../hook/useLoading";

export const ZipCodeInput = ({
  onBlur,
  getValues,
  changeInputs,
  value,
  ...rest
}) => {
  const { loadingWithTime } = useLoading();

  const validate = async (valueInput) => {
    if (valueInput.target.rawValue !== value) {
      if (valueInput.target.rawValue) {
        loadingWithTime(1000);
        await fetch(
          `https://viacep.com.br/ws/${valueInput.target.rawValue}/json`
        ).then(async (response) => {
          const responseJson = await response.clone().json();
          if (responseJson.erro === "true") {
            notifyError("CEP não encontrado");
            return;
          }
          onBlur(valueInput);
          changeInputs(await response.json());
        });
      }
    }
  };

  return (
    <Cleave
      {...rest}
      onBlur={validate}
      value={value}
      placeholder="Digite o CEP para pesquisar"
      options={{
        delimiters: [".", "-"],
        blocks: [2, 3, 3],
        uppercase: true,
      }}
    />
  );
};
